import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { historyService } from '../../services/historyService';

export const useGetRoundLoanGroupsById = (id, enabled) => {
  return useQuery({
    staleTime: Infinity,
    enabled,
    queryKey: [QUERY_KEYS.history.loan_groups_by_id, id],
    queryFn: () =>
      historyService.loanGroupsById(id).then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        throw new Error('Fetch failed');
      }),
  });
};
